import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a56f3f8c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "file-preview-progress__percent" }

import { computed, PropType } from "vue";
import { FilePreviewVariantEnum } from "../../enums";


export default /*#__PURE__*/_defineComponent({
  __name: 'file-preview-progress',
  props: {
  /**Вариант компонента */
  variant: {
    type: String as PropType<FilePreviewVariantEnum>,
    required: true,
  },
  /**Прогресс (в процентах) */
  progress: {
    type: Number,
    default: 0,
  },
  /**В обработке */
  isProccessing: {
    type: Boolean,
    default: false,
  },
  /**Ширина прогрессбара */
  progressbarWidth: {
    type: String,
    default: "auto",
  },
},
  setup(__props) {

const props = __props;



const percentStr = computed(() => `${Number(props.progress.toFixed(2))}%`);
/**Шинира заполненности */
const fillWidth = computed(() =>
  props.isProccessing ? "35%" : `${props.progress}%`
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([
      'file-preview-progress',
      {
        'is-regular-variant': __props.variant === _unref(FilePreviewVariantEnum).Regular,
        'is-inline-variant': __props.variant === _unref(FilePreviewVariantEnum).Inline,
        'is-small-variant': __props.variant === _unref(FilePreviewVariantEnum).Small,
        'is-proccessing': __props.isProccessing,
      },
    ])
  }, [
    _createElementVNode("div", {
      class: "file-preview-progress__line-bg",
      style: _normalizeStyle({ width: __props.progressbarWidth })
    }, [
      _createElementVNode("div", {
        class: "file-preview-progress__line-fill",
        style: _normalizeStyle({ width: fillWidth.value })
      }, null, 4)
    ], 4),
    _createElementVNode("span", _hoisted_1, _toDisplayString(percentStr.value), 1)
  ], 2))
}
}

})